// eslint-disable-next-line simple-import-sort/imports
import React, { useState } from 'react'
// eslint-disable-next-line no-unused-vars
import { hot } from 'react-hot-loader';

import { useParams } from 'react-router-dom';

import BreadCrumb from '../../../../components/BreadCrumb';
import Container from '../../../../components/Container';
import PageTitle from '../../../../components/PageTitle';
import TitleBar from '../../../../components/TitleBar';

import FiscalYearExperimentList from './components/FiscalYearExperimentList';

import { listExperimentsByFiscalYear } from '../../../../sdk/apis';

import { fiscalYearsUrl } from '../../urls';
import { fisYear2Year } from '../FiscalYears/components/FiscalYearList';
import BottomBar from '../../../../components/BottomBar';



const FiscalYearExperiments = () => {
  const { year } = useParams();
  const fiscalYear = parseInt(year);

  const breadcrumbData = [];
  breadcrumbData.push({ title: '実験一覧', url: fiscalYearsUrl() });
  breadcrumbData.push({ title: fisYear2Year(fiscalYear) });

  const [experimentList, setExperimentList] = useState(null);

  if (experimentList === null) {
    listExperimentsByFiscalYear(fiscalYear).then((data) => {
      const sortedData = Array.from(data.sort(function (a, b) {
        return (b.experiment_number !== null || a.experiment_number > b.experiment_number) ? -1 : 1;
      }).sort(function (a, b) {
        return (b.experiment_number === null || a.experiment_number > b.experiment_number) ? -1 : 1;
      }));
      setExperimentList(sortedData);
    });

    return null;
  }


  return (
    <>
      <TitleBar />
      <Container>
        <BreadCrumb data={breadcrumbData} />
        <PageTitle>{fisYear2Year(fiscalYear)}一覧</PageTitle>

        <FiscalYearExperimentList experiments={experimentList} />

      </Container>
      <BottomBar />
    </>
  );
};

export default FiscalYearExperiments;
